import { render, staticRenderFns } from "./bi-dev-menu.vue?vue&type=template&id=66c52828&"
import script from "./bi-dev-menu.vue?vue&type=script&lang=ts&"
export * from "./bi-dev-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports